function Layout({ languages, handler, locale }) {
  function LanguageSelector() {
    return (
      <div className="language">
        Select Your Language
        <form
          action="/togo_language_selection"
          id="togo-language-select-form"
          acceptCharset="UTF-8"
          method="get"
        >
          <select
            id="togo-language-select"
            name="togo_language"
            onChange={handler}
            value={locale}
          >
            {Object.keys(languages).map((key) => (
              <option key={key} value={key}>
                {languages[key]}
              </option>
            ))}
          </select>
        </form>
      </div>
    )
  }

  return (
    <div className="body-padding row">
      <div className="nav-right">
        <a href="http://www.cambro.com">Cambro.com</a>
      </div>
      <div className="translation">
        <LanguageSelector />
      </div>
      <div className="cambro-logo">
        <a href="http://apps.cambro.com">
          <img src="/assets/logo-cambro-apps.png" width="200px" />
        </a>
      </div>
    </div>
  )
}

Layout.defaultProps = {
  languages: {
    de: "German",
    en: "English",
    fr: "French",
    ru: "Russian",
  },
}

export default Layout
